// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__G3N9j","title":"header_title__Ok1kZ"};